import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Info } from '../model/info';

@Service()
export class InfoService {
  readonly #http = inject(HttpClient);

  getInfo$(): Observable<Info> {
    return this.#http.get<any[]>('/api/info').pipe(map(data => new Info(data)));
  }
}
